<template>
  <q-card
    flat
    bordered
    class="q-pa-md q-mt-md"
    v-if="campaignValidationHistory && Object.keys(campaignValidationHistory).length > 0"
    style="background-color: #f3e5f5"
  >
    <div class="row q-pt-md q-gutter-x-sm">
      <div class="col-4">
        <p>
          <b>{{ $t('campaign_id') }}:</b> <span>{{ campaignValidationHistory.campaign_id }}</span>
        </p>
        <p>
          <b>{{ $t('full_commission') }}:</b>
          <span>
            {{
              campaignValidationHistory.comissao_full
                ? parseFloat(campaignValidationHistory.comissao_full).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                  })
                : null
            }}</span
          >
        </p>
        <p>
          <b>{{ $t('approved_full_commission') }}:</b>
          <span>
            {{
              campaignValidationHistory.comissao_full_aprovada
                ? parseFloat(campaignValidationHistory.comissao_full_aprovada).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                  })
                : null
            }}</span
          >
        </p>
        <p>
          <b>{{ $t('margin') }}:</b>
          <span>
            {{
              campaignValidationHistory.margem
                ? parseFloat(campaignValidationHistory.margem).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                  })
                : null
            }}</span
          >
        </p>
        <p>
          <b>{{ $t('approved_margin') }}:</b>
          <span>
            {{
              campaignValidationHistory.margem_aprovada
                ? parseFloat(campaignValidationHistory.margem_aprovada).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                  })
                : null
            }}</span
          >
        </p>
      </div>
      <div class="col-5">
        <p>
          <b>Status:</b> <span>{{ campaignValidationHistory.status }}</span>
        </p>
        <p>
          <b
            >{{ $t('capture_rate') }}:<q-icon name="mdi-help-circle-outline" size="1.1em"
              ><q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
                 {{ $t('capture_rate_tooltip') }}
              </q-tooltip></q-icon
            ></b
          >
          <span>&nbsp;{{ campaignValidationHistory.taxa_captacao.toFixed(2) }} %</span>
        </p>
        <p>
          <b
            >Taxa de validação:<q-icon name="mdi-help-circle-outline" size="1.1em"
              ><q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
                Comissão full aprovada / Comissão full captada <br />(Em caso de validação concluída)
              </q-tooltip></q-icon
            ></b
          >
          <span>&nbsp;{{ campaignValidationHistory.taxa_validacao.toFixed(2) }} %</span>
        </p>
        <p>
          <b
            >{{ $t('full_commission_comparison') }}:<q-icon name="mdi-help-circle-outline" size="1.1em"
              ><q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
                {{ $t('full_commission_comparison_tooltip') }}
              </q-tooltip></q-icon
            ></b
          >
          <span>&nbsp;R$ {{ campaignValidationHistory.comissao_mes_anterior }}</span>
        </p>
        <p>
          <b>Comparativo de margem validada:</b> <span>R$ {{ campaignValidationHistory.margem_mes_anterior }}</span>
        </p>
      </div>
      <div class="col-2">
        <p>
          <b>Total:</b>
          <span> {{ campaignValidationHistory.total }}</span>
        </p>
        <p>
          <b>{{ $t('pending') }}:</b> <span>{{ campaignValidationHistory.pendentes }}</span>
        </p>
        <p>
          <b>{{ $t('approved') }}:</b> <span>{{ campaignValidationHistory.aprovadas }}</span>
        </p>
        <p>
          <b>{{ $t('refused') }}:</b> <span>{{ campaignValidationHistory.recusadas }}</span>
        </p>
      </div>
    </div>
  </q-card>
</template>

<script>
export default {
  name: 'CardValidationHistory',
  props: {
    campaignValidationHistory: { type: Object, default: null }
  }
};
</script>

<style></style>
